export const basicEducationData = {
    my: {
        title: "အခြေခံပညာရေး",
        subtitle: "မဟာဝိဟာရ၏ ပညာရေးအုတ်မြစ်",
        mainContent: {
            introduction: "ဤအခြေခံပညာရေးသည် များသောအားဖြင့် နိုင်ငံခြားသား ရဟန်း, သာမဏေများနှင့် တိုင်းရင်းသားကိုရင်များအတွက် ဖြစ်၏။",
            diversity: "မဟာဝိဟာရကျောင်းတိုက်တွင် တိုင်းနှင့် ပြည်နယ်အသီးသီးမှ ရောက်လာကြသည့်အတွက် စာသင်သားများသည် အရွယ်စုံ လူမျိုးစုံ ရှိ၏။",
            quote: "တိုင်းရင်းသားမျိုးစုံကို ကြည့်လိုလျှင် မဟာဝိဟာရသို့ ကြွခဲ့ပါ"
        },
        curriculum: {
            subjects: [
                "မြန်မာစာ",
                "သင်္ချာ",
                "အင်္ဂလိပ်စာ",
                "ဗုဒ္ဓဝင်အမေး+အဖြေ",
                "ဗုဒ္ဓဘာသာလက်စွဲ"
            ],
            duration: "၁-နှစ်နှင့် ၆-လအတွင်း ၄-လလျှင် တစ်တန်းနှုန်းဖြင့် စတုတ္ထတန်းပညာ အရည်အချင်း အထိ",
            teachers: "စာသင်သားရဟန်းတော်များထဲမှ လောကီဘွဲ့ရပြီးမှ သာသနာ့ဘောင်သို့ ဝင်ရောက်လာသော ရဟန်းတော်များ"
        },
        progression: "ထိုသို့ မြန်မာစာကို တတ်မြောက်ပြီးမှ နံပါတ် ၂-ပိဋကတ်အခြေပြုပညာရေးနယ်ပယ်သို့ ခြေလှမ်းခွင့်ရ၏။"
    },
    en: {
        title: "Basic Education",
        subtitle: "Educational Foundation at Mahãvihãra",
        mainContent: {
            introduction: "This basic education program primarily serves foreign monks, novices, and ethnic minority students.",
            diversity: "Mahãvihãra hosts students of all ages and ethnicities from various states and regions.",
            quote: "To witness the diversity of ethnic groups, visit Mahãvihãra"
        },
        curriculum: {
            subjects: [
                "Myanmar Language",
                "Mathematics",
                "English",
                "Buddhist Life Q&A",
                "Buddhism Handbook"
            ],
            duration: "Completion of fourth-grade level education within 1.5 years, with each grade taking 4 months",
            teachers: "Taught by monk-students who entered monkhood after obtaining secular degrees"
        },
        progression: "After mastering Myanmar language, students can advance to the Level 2 Pitaka-based education program."
    }
};